import { render, staticRenderFns } from "./RowBlockWritingOffCommissionGreenCard.vue?vue&type=template&id=53032e86&"
import script from "./RowBlockWritingOffCommissionGreenCard.vue?vue&type=script&lang=js&"
export * from "./RowBlockWritingOffCommissionGreenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports